module.exports = __webpack_public_path__ + "static/media/partner.ec281f90.png";